module.exports = __webpack_public_path__ + "static/mr-press-32-b61eec693763b0fd8f693494860c62a9.jpg";